// Enums

import { staticConfig } from '../config/static';
import { SupportedMimeType } from '../enums';
// Interfaces
import { IArtifact } from '../interfaces/artifact.interfaces';
import JSZip from 'jszip';
import saveAs from 'file-saver';

const serviceUrl = '/artifactservice/v2';

export const printDocument = async (mailboxId: string, artifact: IArtifact, isRtl?: boolean): Promise<void> => {
    const url =
        staticConfig.apiBaseUrl +
        serviceUrl +
        `/mailboxes/${mailboxId}/messages/${artifact.messageId}/artifacts/${artifact.id}/files/${artifact.files[0].id}/content?mimeType=${artifact.files[0].encodingFormat}`;

    const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': artifact.files[0].encodingFormat },
        credentials: 'include',
    });

    const blob = await response.blob();

    const objectUrl = URL.createObjectURL(blob);

    const printFrame = document.createElement('iframe');
    printFrame.src = objectUrl;

    printFrame.addEventListener('afterprint', () => {
        printFrame.parentNode.removeChild(printFrame);
        URL.revokeObjectURL(objectUrl);
    });

    printFrame.addEventListener('load', () => {
        const direction = isRtl ? 'rtl' : 'ltr';
        injectDirectionScriptIntoIframe(printFrame, direction);
        printFrame.contentWindow.print();
    });

    document.body.appendChild(printFrame);
};

export const downloadDocument = async (mailboxId: string, artifact: any, isRtl?: boolean): Promise<void> => {
    const urls = artifact.map((fileData: any) => {
        const getUrl = fileData.files.map((item: any) => {
            return {
                url:
                    staticConfig.apiBaseUrl +
                    serviceUrl +
                    `/mailboxes/${mailboxId}/messages/${fileData.messageId}/artifacts/${fileData.id}/files/${item.id}/content?mimeType=${item.encodingFormat}`,
                filename: item.filename,
                contentType: item.encodingFormat,
                dateCreation: fileData.dateCreated,
            };
        });
        return getUrl;
    });
    if (urls.length == 1 && urls[0].length == 1) {
        const data = urls[0][0];
        return new Promise<void>((resolve, reject) => {
            fetch(urls[0][0].url, {
                method: 'GET',
                headers: { 'Content-Type': data.contentType },
                credentials: 'include',
            })
                .then((response) => response.blob())
                .then((blob) => {
                    const a = document.createElement('a');
                    a.href = window.URL.createObjectURL(blob);
                    artifact.map((fileData: any) => {
                        const formattedDate = new Date(fileData.dateCreated).toISOString().split('T')[0];
                        a.download = `${formattedDate}_${data.filename}`;
                    });
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    } else {
        const today = new Date().toISOString().split('T')[0];
        const filename = today;
        const zip = new JSZip();
        const folder = zip.folder('');
        const urlsFlatArray = urls.flat();
        urlsFlatArray.map((url: any, indx: any) => {
            const blobPromise = fetch(url.url, {
                method: 'GET',
                headers: { 'Content-Type': url.contentType },
                credentials: 'include',
            }).then(function (response) {
                if (response.status === 200 || response.status === 0) {
                    return Promise.resolve(response.blob());
                } else {
                    return Promise.reject(new Error(response.statusText));
                }
            });
            const formattedDate = new Date(url.dateCreation).toISOString().split('T')[0];
            const name =
                url.type === 'MessageBodyDocument'
                    ? `${formattedDate}_${url.title}${indx + 1}.${url.filename.split('.')[1]}`
                    : url.filename.split('.').length > 0
                    ? url.filename.includes('txt')
                        ? `${formattedDate}_${url.filename.split('.')[0]}${indx + 1}.${url.filename.split('.')[1]}`
                        : `${formattedDate}_${url.filename.split('.')[0]}${indx + 1}.${url.contentType.split('/')[1]}`
                    : url.filename.includes('txt')
                    ? `${formattedDate}_${url.filename}${indx + 1}.${url.filename.split('.')[1]}`
                    : `${formattedDate}_${url.filename}${indx + 1}.${url.contentType.split('/')[1]}`;
            folder.file(name, blobPromise);
        });
        zip.generateAsync({ type: 'blob' })
            .then((blob) => saveAs(blob, filename))
            .catch((e) => console.log(e));
    }
};

export const isPrintable = (mimeType: SupportedMimeType): boolean =>
    Object.values(SupportedMimeType).includes(mimeType);

// Necessary to inject custom script tag into iframe to avoid XSS protection in some browsers
const injectDirectionScriptIntoIframe = (frame: HTMLIFrameElement, direction: string): void => {
    const directionScript = document.createElement('script');

    directionScript.innerHTML = `document.querySelector('html').setAttribute('dir', '${direction}');`;

    frame.appendChild(directionScript);
};
